import Icon from '../components/Icon.vue'

Icon.register({"tablet":{"width":1152,"height":1792,"paths":[{"d":"M640 1408q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1024 1248v-960q0-13-9.5-22.5t-22.5-9.5h-832q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h832q13 0 22.5-9.5t9.5-22.5zM1152 288v1088q0 66-47 113t-113 47h-832q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h832q66 0 113 47t47 113z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tablet.js
// module id = 664z
// module chunks = 1